type ModalContentPropsType = {
  children: React.ReactNode;
};

const ModalContent = ({
  children,
}: ModalContentPropsType): React.ReactElement => {
  return (
    <div className="font_body_regular_lg content_secondary">{children}</div>
  );
};

export default ModalContent;
